import { gql } from '@apollo/client';

export default gql`
  mutation OvertimeSendExternalEmail($input: SendOvertimeExternalLinkEmailInput!) {
    sendOvertimeExternalLinkEmail(input: $input) {
      status
    }
  }
`;
